// extracted by mini-css-extract-plugin
export var bold = "_y1-0";